import MeetRoomContext from '@src/contexts/MeetRoomContext';
import { TMediaRequest } from '@src/types';
import { useCallback, useContext, useEffect } from 'react';

interface Props {
  open: boolean;
  request: TMediaRequest;
  onConfirm: () => void;
  onClose: () => void;
}

const useMediaRequestCta = ({ open, request, onConfirm, onClose }: Props) => {
  const { processedMediaRequest, setProcessedMediaRequest } = useContext(MeetRoomContext);
  useEffect(() => {
    if (open) {
      if (!processedMediaRequest) {
        setProcessedMediaRequest(request);
      }
    }
  }, [open, processedMediaRequest, setProcessedMediaRequest, request]);

  const handleOnConfirm = useCallback(() => {
    onConfirm();
    setProcessedMediaRequest(null);
  }, [setProcessedMediaRequest]);

  const handleOnClose = useCallback(() => {
    onClose();
    setProcessedMediaRequest(null);
  }, [setProcessedMediaRequest]);

  return {
    processedMediaRequest,
    handleOnConfirm,
    handleOnClose,
  };
};

export default useMediaRequestCta;
